/**
 * This handles regular card payments for Stripe
 * It sets up the 3x fields - card number, expiry date, and CVC - and handles the payment submission
 */

import stripeStyles from 'Scripts/donate-form/stripe-styles';
import fetchJson    from 'Scripts/common/fetch-json';

export default class StripeCardElements {
	constructor(parent, args) {
		console.log('StripeCardElements.constructor');

		this.parent = parent;

		this.callbacks = {
			onUnmount: args?.onUnmount,
			onReset: args?.onReset,
			onSuccess: args?.onSuccess,
		};

		// If lots of errors then we disable Stripe elements
		this.errorCount = 0;

		this.createElements();
		this.bindEvents();
	}

	createElements() {
		console.log("StripeCardElements.createElements");

		const elements = this.parent.stripe.elements({
			fonts: stripeStyles.fonts
		});

		const appearance = stripeStyles.cardElementStyles;

		const elementClasses = {
			focus: 'focus',
			empty: 'empty',
			invalid: 'parsley-error'
		};

		$('.card-error').hide();

		this.cardNumber = elements.create('cardNumber', {
			placeholder: '',
			style: appearance,
			classes: elementClasses
		});

		this.cardNumber.mount('#card-number');

		this.cardExpiry = elements.create('cardExpiry', {
			placeholder: '',
			style: appearance,
			classes: elementClasses
		});

		this.cardExpiry.mount('#card-expiry');

		this.cardCvc = elements.create('cardCvc', {
			placeholder: '',
			style: appearance,
			classes: elementClasses
		});

		this.cardCvc.mount('#card-cvc');
	}

	bindEvents() {
		this.cardNumber.on('ready', this.onCardNumberReady.bind(this));
		this.cardExpiry.on('ready', this.onCardExpiryReady.bind(this));
		this.cardCvc.on('ready', this.onCardCvcReady.bind(this));
	}

	onCardNumberReady(e) {
		this.cardNumber.on('change', event => {
			this.toggleError(event)

			if(event.error) {
				this.errorCount ++;

				if(this.errorCount > 9) {
					cardNumber.unmount();

					if(this.callbacks.onUnmount) {
						this.callbacks.onUnmount();
					}
				}
			}
		});
	}

	onCardExpiryReady(e) {
		this.cardExpiry.on('change', event => {
			this.toggleError(event)
		});
	}

	onCardCvcReady(e) {
		this.cardCvc.on('change', event => {
			this.toggleError(event)
		});
	}

	// This is called when Stripe complains about the card details inputs
	toggleError(event) {
		const container = $("#stripe-error-container");

		if(event.error) {
			console.log("StripeCardElements.toggleError", event.error);

			if(event.error.message.indexOf('You passed an empty string') > -1) {
				event.error.message = "Please complete all required fields";
			}

			container.find(".parsley-required").text(event.error.message);
			container.show();
		}  else {
			container.hide();
		}
	}

	handlePayment() {
		console.log("StripeCardElements.handleCardDonation");

		const billingDetails = this.extractBillingDetails();
		console.log("billingDetails", billingDetails);

		// Initial post to Stripe. This returns a paymentMethod.id token that is passed to our backend.
		this.parent.stripe.createPaymentMethod("card", this.cardNumber, billingDetails)
		.then(result => {
			if (result.error) {
				// This is going to be an error where Stripe complains about the form inputs.
				this.toggleError(result)

				if(this.callbacks.onReset) {
					this.callbacks.onReset();
				}

				return;
			}

			// Updates some hidden fields
			this.parent.paymentMethods.updateFields(result);

			this.submitPayment();
		});
	}

	async submitPayment(result) {
		console.log("StripeCardElements.submitPayment");

		// Initial AJAX request to create donation row in our database.
		try {
			const { success, result } = await fetchJson(this.parent.ui.forms.donation.attr('action'), {
				method: 'POST',
				body: new FormData(this.parent.ui.forms.donation[0]),
			});

			if(!success) {
				throw new Error();
			}

			console.log("StripeCardElements.submitPayment", "result", result);

			if(this.callbacks.onSuccess) {
				this.callbacks.onSuccess(result);
			}

			return this.parent.stripeUtils.verify(result);

		} catch (error) {
			console.log("StripeCardElements", "Payment error", error);

			this.handleFatalError(error);
		}
	}

	extractBillingDetails() {
		return {
			"billing_details": {
				"email": $('input[name=email]').val(),
				"name": $('#billing-name').val(),
				"address": {
					"line1": $('#billing-address-1').val(),
					"line2": $('#billing-address-2').val(),
					"city": $('#billing-city').val(),
					"state": $('#billing-state').val(),
					"postal_code": $('#billing-zip').val(),
					"country": $('#billing-country').val(),
				}
			}
		};
	}

	handleFatalError(error) {
		this.parent.showDeclinedScreen(error);
		this.cardNumber.destroy();
		this.cardExpiry.destroy();
		this.cardCvc.destroy();
	}
}